
const Gradient1 = () => {

    return (
        <svg className="" xmlns="http://www.w3.org/2000/svg" width={'0'} height={'0'} style={{position:'absolute',top:'0',left:'0'}} viewBox="0 0 3500 5000">
            <defs>
                <linearGradient id="gradienteRojoAzul" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stop-color="#fa0000" />
                    <stop offset="100%" stop-color="#000" />
                </linearGradient>
            </defs>
        </svg>
    )
}

export default Gradient1;